import { ChangeDetectorRef, Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { BurdSameDayDeliveryService } from '@shared/same-day-delivery/burd-same-day-delivery.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { weekendMode } from '@shared/same-day-delivery/same-day-delivery.helper';

/**
 * appSameDayDeliveryInOffMode it's used to control the weekend or holiday modes
 */
@UntilDestroy()
@Directive({
    selector: '[appSameDayDeliveryInOffMode]',
    standalone: true
})
export class SameDayDeliveryInOffModeDirective implements OnInit {
    constructor(
        private readonly sameDayDeliveryService: BurdSameDayDeliveryService,
        private readonly cd: ChangeDetectorRef,
        private readonly templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        this.sameDayDeliveryService
            .getBurdDeliveryTimeLeft()
            .pipe(take(1), untilDestroyed(this))
            .subscribe(({ dayOfWeek = 0, onTimeForSameDayDelivery, isHoliday = false }) => {
                const isInWeekendMode = weekendMode(dayOfWeek, onTimeForSameDayDelivery);
                this.updateView(isInWeekendMode, isHoliday);
            });
    }

    private updateView(isInWeekendMode: boolean, isHoliday: boolean) {
        if (isInWeekendMode || isHoliday) {
            this.viewContainerRef.clear();
            return;
        }

        this.viewContainerRef.createEmbeddedView(this.templateRef);
        this.cd.markForCheck();
    }
}
